module.exports = {
    className: "AppThumb",
    classNameLabel: "App Thumb",
    limit: 10,
    showExport: false,
    columns: [
        {
            columnName: "objectId",
            type: "string"
        },
        {
            columnName: "title",
            type: "string"
        },
        {
            columnName: "browser",
            type: "string",
            show: false
        },
        {
            columnName: "url",
            type: "string",
            style: {
                whiteSpace: "normal",
                minWidth: "200px"
            }
        },
        {
            columnName: "startDate",
            columnLabel: "start Date",
            type: "date",
            format: 'MMM DD, YYYY hh:mm A'
        },
        {
            columnName: "endDate",
            columnLabel: "end Date",
            type: "date",
            format: 'MMM DD, YYYY hh:mm A'
        },
        {
            columnName: "sort",
            type: "number",
        },
        {
            columnName: "image",
            columnLabel: "Image",
            type: "ParseFile",
            show: false
        },
        {
            columnName: "imageBg",
            columnLabel: "Image Background",
            type: "ParseFile",
            show: false
        },
        {
            columnName: "createdAt",
            type: "Date"
        },
        {
            columnName: "updatedAt",
            type: "Date"
        }
    ]
}


// WEBPACK FOOTER //
// ./components/AppThumb/AppThumbSchema.js